import { Box, Typography } from '@mui/material';

interface ErrorStateProps {
    message: string;
}

export const ErrorState = ({ message }: ErrorStateProps) => {
    return (
        <Box sx={{ padding: '60px 40px', textAlign: 'center' }}>
            <Typography sx={{ fontSize: '2rem', marginBottom: 2 }}>⚠️</Typography>
            <Typography sx={{ color: '#dc2626', fontWeight: 500, fontSize: '1rem' }}>
                {message}
            </Typography>
        </Box>
    );
};
